import * as Notifications from "expo-notifications";
import { Platform } from "react-native";

import { captureException } from "../sentry";
import Constants from "expo-constants";

if (Platform.OS !== "web") {
  Notifications.setNotificationHandler({
    handleNotification: async (notification) => {
      if (
        notification.request.content.title ||
        notification.request.content.body
      ) {
        return {
          shouldShowBanner: true,
          shouldShowList: true,
          shouldPlaySound: true,
          shouldSetBadge: true,
        };
      }
      return {
        shouldShowBanner: false,
        shouldShowList: false,
        shouldPlaySound: false,
        shouldSetBadge: true,
      };
    },
  });
}

export const getNotificationToken = async () => {
  if (Platform.OS === "web") {
    return Promise.reject(new Error("Not supported"));
  }
  if (Platform.OS === "android") {
    try {
      await Notifications.setNotificationChannelAsync("default", {
        name: "StoreSprint",
        importance: Notifications.AndroidImportance.MAX,
        lockscreenVisibility:
          Notifications.AndroidNotificationVisibility.PUBLIC,
        showBadge: true,
        enableVibrate: true,
        enableLights: true,
        vibrationPattern: [0, 250, 250, 250],
        lightColor: "#0066ff",
      });
    } catch (e) {
      captureException(e);
    }
  }

  const { status } = await Notifications.getPermissionsAsync();
  if (status !== "granted") {
    // not granted ask
    const answer = await Notifications.requestPermissionsAsync({
      ios: {
        allowAlert: true,
        allowBadge: true,
        allowSound: true,

        allowDisplayInCarPlay: true,
        allowCriticalAlerts: true,
      },
    });
    if (answer.status !== "granted") {
      return Promise.reject(new Error("Not granted"));
    }
  }
  return Notifications.getExpoPushTokenAsync({
    projectId: Constants?.expoConfig?.extra?.eas.projectId,
  }).catch((e) => {
    captureException(e);
    return Promise.reject(e);
  });
};
